<template>
  <div>
    <div class="d-flex">
      <div class="pl-3" style="width:20%;">
        <TabPaneVertical :activeTab="activeTab" @clickTab="(val)=> activeTab = val"/>
      </div>
      <div style="width: 80%;">
        <form @submit.prevent="onSave">
          <b-row v-if="detailMi">
            <b-col md="12" class="text-right mb-3">
              <b-button variant="primary" @click="isPreview = !isPreview">{{ isPreview?'Edit' :'Preview' }} ERM</b-button>
            </b-col>
            <b-col md="6">
              <b-row class="px-4">
                <b-col cols="12">
                  <h5 class="card-title text-primary"><strong>Enterprise Risk Management Assessor :</strong></h5>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Name" >
                    <b-form-input
                      v-if="!isPreview"
                      required
                      class="w-100"
                      type="text"
                      v-model="form.assessor_fullname"
                      placeholder="Name..."
                    ></b-form-input>
                    <h6 v-else>{{ form.assessor_fullname ?? '-' }}</h6>
                  </b-form-group>
                  <b-form-group label="Department">
                    <template v-if="isPreview">
                      {{departments.find(department => department.code === form.assessor_department_id) ? departments.find(department => department.code === form.assessor_department_id).name : '-'}}
                    </template>
                    <v-select
                      v-else
                      required
                      v-model="form.assessor_department_id"
                      label="name"
                      :options="departments"
                      :reduce="(department) => department.code"
                    ></v-select>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Company">
                    <template v-if="isPreview">
                      {{companies.find(company => company.id === form.assessor_company_id) ? companies.find(company => company.id === form.assessor_company_id).company : '-'}}
                    </template>
                    <v-select
                      v-else
                      required
                      v-model="form.assessor_company_id"
                      label="company"
                      :options="companies"
                      :reduce="(companyOptions) => companyOptions.id"
                    ></v-select>
                  </b-form-group>
                  <b-form-group label="ERM Credential ">
                    <b-form-input
                      v-if="!isPreview"
                      required
                      class="w-100"
                      v-model="form.assessor_erm_credential"
                      type="text"
                      placeholder=""
                    ></b-form-input>
                    <h6 v-else>{{ form.assessor_erm_credential ?? '-' }}</h6>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="6">
              <b-row class="px-4">
                <b-col cols="12">
                  <h5 class="card-title text-primary"><strong>Enterprise Risk Management Target :</strong></h5>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Person In Charge">
                    <h6 v-if="isPreview">{{ form.target_pic ?? '-' }}</h6>
                    <b-form-input
                      v-else
                      required
                      v-model="form.target_pic"
                      class="w-100"
                      type="text"
                      placeholder="PIC"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group label="Department">
                    <template v-if="isPreview">
                      {{departments.find(department => department.code === form.target_department_id) ? departments.find(department => department.code === form.target_department_id).name : '-'}}
                    </template>
                    <v-select
                      v-else
                      required
                      v-model="form.target_department_id"
                      multiple
                      label="name"
                      :options="departments"
                      :reduce="(department) => department.code"
                    ></v-select>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Location">
                    <h6 v-if="isPreview">{{ form.target_location ?? '-' }}</h6>
                    <b-form-input
                    v-else
                    required
                    v-model="form.target_location"
                    class="w-100"
                    type="text"
                    placeholder=""
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group label="Month Assessment">
                    <h6 v-if="isPreview">{{ moment(form.date_range[0]).format('DD MMM YYYY')}} - {{ moment(form.date_range[2]).format('DD MMM YYYY') }}</h6>
                    <date-picker
                      v-else
                      class="w-100"
                      :disabled="isPreview"
                      @change="onChangeDate()"
                      v-model="form.date_range"
                      required
                      value-type="YYYY-MM-DD"
                      format="DD MMM YYYY"
                      type="date"
                      range
                      placeholder="Select date range"
                    ></date-picker>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
    
            <!-- Sasaran Smart -->
            <b-col md="12" class="mt-3" v-if="activeTab == 1">
              <div class="px-4">
                <h5 class="text-primary mb-2"><strong>Sasaran Smart</strong></h5>
                <table class="table">
                  <thead>
                    <tr>
                      <th width="4%" class="text-center">No</th>
                      <th width="16%">Sasaran</th>
                      <th width="16%">Spesific</th>
                      <th width="16%">Measurable</th>
                      <th width="16%">Achievable</th>
                      <th width="16%">Relevant</th>
                      <th width="16%">Time-Bound</th>
                      <th width="4%" class="text-center" v-if="!isPreview">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(data, index) in form.sasaran_smart"
                      :key="index"
                    >
                      <td class="text-center">{{ index + 1 }}</td>
                      <td>
                        <template v-if="isPreview">
                          {{data.sasaran}}
                        </template>
                        <b-form-textarea
                          v-else
                          @change="onSasaranSmartChanged(index)"
                          v-model="data.sasaran"
                          placeholder="Input your text..."
                          style="line-height: 20px"
                          rows="4"
                        ></b-form-textarea>
                      </td>
                      <td>
                        <template v-if="isPreview">
                          {{data.spesific}}
                        </template>
                        <b-form-textarea
                          v-else
                          @change="onSasaranSmartChanged(index)"
                          v-model="data.spesific"
                          style="line-height: 20px"
                          rows="4"
                        ></b-form-textarea>
                      </td>
                      <td>
                        <template v-if="isPreview">
                          {{data.measurable}}
                        </template>
                        <b-form-textarea
                          v-else
                          v-model="data.measurable"
                          style="line-height: 20px"
                          rows="4"
                        >
                        </b-form-textarea>
                      </td>
                      <td>
                        <template v-if="isPreview">
                          {{data.achievable}}
                        </template>
                        <b-form-textarea
                          v-else
                          v-model="data.achievable"
                          style="line-height: 20px"
                          rows="4"
                        >
                        </b-form-textarea>
                      </td>
                      <td>
                        <template v-if="isPreview">
                          {{data.relevant}}
                        </template>
                        <b-form-textarea
                          v-else
                          v-model="data.relevant"
                          style="line-height: 20px"
                          rows="4"
                        >
                        </b-form-textarea>
                      </td>
                      <td>
                        <h6 v-if="isPreview">{{ moment(data.timebound).format('DD MMM YYYY') }}</h6>
                        <date-picker
                          v-else
                          v-model="data.timebound"
                          :disabled="isPreview"
                          value-type="YYYY-MM-DD"
                          format="DD MMM YYYY"
                          type="date"
                          placeholder="Select date"
                        ></date-picker>
                      </td>
                      <td v-if="!isPreview">
                        <b-button
                          @click="removeSasaranSmart(index)"
                          variant="danger"
                          ><i class="fa fa-trash"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <b-button
                  variant="warning"
                  v-if="!isPreview"
                  @click="addSasaranSmart"
                  block
                  class="mt-2 mb-3"
                  ><i class="fa fa-plus"></i> Add More Data</b-button
                >
              </div>
            </b-col>
            <!-- Sasaran Smart End -->
    
            <!-- Penamaan Risiko -->
            <b-col md="12" v-if="activeTab == 2" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary mb-2"><strong>Penamaan Risiko</strong></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th width="5%">No</th>
                          <th width="14%">Sasaran</th>
                          <th width="14%">Nama Risiko</th>
                          <th width="14%">Perisitiwa</th>
                          <th width="14%">Sebab</th>
                          <th width="14%">Konsekuensi</th>
                          <th width="14%"
                            >Kategori Risiko</th
                          >
                          <th width="14%">Tindakan</th>
                           <!-- <th width="2%" class="text-center">Action</th> -->
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in form.penamaan_resiko"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>
                            <template v-if="isPreview">
                              {{data.sasaran}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.sasaran" />
                          </td>
                          <td>
                            <h6 v-if="isPreview">{{  data.risiko ? listRisk.find((el)=> el.value == data.risiko).text :'-' }}</h6>
                            <b-form-select
                              v-else
                              plain
                              v-model="data.risiko"
                              :options="listRisk"
                              size="lg"
                            >
                              <template v-slot:first>
                                <b-form-select-option :value="null"
                                  >Select Risk</b-form-select-option
                                >
                              </template>
                            </b-form-select>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.peristiwa}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.peristiwa"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.sebab}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.sebab"
                              style="line-height: 20px"
                              rows="4"
                            ></b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.konsekuensi}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.konsekuensi"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <h6 v-if="isPreview">{{ data.kategori_risiko ? catRisk.find((el)=> el.value == data.kategori_risiko).text : '-'}}</h6>
                            <b-form-select
                              v-else
                              plain
                              v-model="data.kategori_risiko"
                              :options="catRisk"
                              size="lg"
                            >
                              <template v-slot:first>
                                <b-form-select-option :value="null"
                                  >Select</b-form-select-option
                                >
                              </template>
                            </b-form-select>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.tindakan}}
                            </template>
                            <b-form-textarea
                              v-else
                              @change="onPenamaanResikoChanged(index)"
                              v-model="data.tindakan"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                        <!--                          <td>
                            -
                            <b-button
                              variant="danger"
                              @click="removePenamaanResiko(index)"
                              ><i class="fa fa-trash"></i>
                            </b-button>
                          </td>-->
                        </tr>
                      </tbody>
                    </table>
  <!--                    <b-button-->
  <!--                      variant="warning"-->
  <!--                      @click="addPenamaanResiko"-->
  <!--                      block-->
  <!--                      class="mt-2 mb-3"-->
  <!--                      ><i class="fa fa-plus"></i> Add More Data</b-button-->
  <!--                    >-->
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Penamaan Risiko End -->
    
            <!-- Prinsip Manajemen Risiko -->
            <b-col md="12" v-if="activeTab == 3" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Prinsip Manajemen Risiko</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th width="4%">No</th>
                          <th width="25%">Prinsip Manajemen Risiko</th>
                          <th width="25%">Definisi Prinsip</th>
                          <th width="25%">Implementasi Manajemen Risiko</th>
                          <th width="25%">Status Implementasi</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in form.prinsip_manajemen_resiko"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>
                            <p>{{ data.prinsip }}</p>
                          </td>
                          <td>
                            <p>{{ data.definisi }}</p>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.implementasi}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.implementasi"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <h6 v-if="isPreview">{{ data.status ? statusImplementasi.find((el)=> el.value == data.status).text : '-' }}</h6>
                            <b-form-select
                              v-else
                              plain
                              v-model="data.status"
                              :options="statusImplementasi"
                              size="lg"
                            >
                              <template v-slot:first>
                                <b-form-select-option :value="null"
                                  >Select</b-form-select-option
                                >
                              </template>
                            </b-form-select>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Prinsip Manajemen Risiko End -->
    
            <!-- Kepemimpinan Dan Komitmen -->
            <b-col md="12" v-if="activeTab == 4"  class="mt-3">
              <div class="px-4">
                <h5 class="text-primary mb-2"><b>Kepemimpinan Dan Komitmen</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th width="5%">No</th>
                          <th width="24%">Pemimpin Risiko</th>
                          <th width="24%">Uraian Tugas Pemimpin Risiko</th>
                          <th width="24%">Dokumen Pendukung</th>
                          <th width="24%">Remarks</th>
                          <th width="4%" v-if="!isPreview" class="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in form.kepemimpinan_komitmen"
                          :key="index"
                        >
                          <td>{{index + 1}}</td>
                          <td>
                            <h6 v-if="isPreview">{{ data.pimpinan ?? '-' }}</h6>
                            <b-form-input v-else required v-model="data.pimpinan" class="w-100" type="text" placeholder=""></b-form-input>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.tugas}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.tugas"
                              style="line-height: 20px"
                              rows="4"
                            ></b-form-textarea>
                          </td>
                          <td>
                            <div v-if="data.dokumen || isPreview" class="d-flex justify-content-between">
                              <template v-if="data.dokumen">
                                <a :href="data.dokumen" class="text-primary" v-b-tooltip.hover title="Download File" download><i class="fa fa-download"></i> Download</a>
                                <a v-if="!isPreview" href="#" @click.prevent="data.dokumen = ''" class="text-danger" v-b-tooltip.hover title="Hapus" download><i class="fa fa-trash"></i></a>
                              </template>
                              <template v-else>
                                <div>
                                  -
                                </div>
                              </template>
                            </div>
                            <template v-else>
                              <div class="custom-file">
                                <input
                                  :id="`commitment-file-input-${index}`"
                                  type="file"
                                  @change="
                                  onKepemimpinanKomitmentFileChanged(
                                    index,
                                    $event
                                  )
                                "
                                  accept="image/png,image/jpg,image/jpeg,.pdf,.xls,.xlsx,.doc,.docx"
                                  class="custom-file-input"
                                />
                                <label
                                  class="custom-file-label"
                                  :for="`commitment-file-input-${index}`"
                                >Browse file...</label
                                >
                              </div>
                              <small class="text-muted">
                                File Type * :
                                <b-badge variant="info"
                                >.jpg | .jpeg | .png | .xlx | .xlxs | .doc |
                                  .docs | .pdf</b-badge
                                ><br />
                                File Capacity * :
                                <b-badge variant="info">3 MB / File</b-badge>
                              </small>
                            </template>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.remarks}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.remarks"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td v-if="!isPreview">
                            <b-button
                              variant="danger"
                              @click="removeKepemimpinanKomitment(index)"
                              ><i class="fa fa-trash"></i
                            ></b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <b-button
                      variant="warning"
                      v-if="!isPreview "
                      @click="addKepemimpinanKomitment"
                      block
                      class="mt-2 mb-3"
                      ><i class="fa fa-plus"></i> Add More Data</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Kepemimpinan Dan Komitmen End -->
    
            <!-- Analisa Pemangku Kepentingan -->
            <b-col md="12" v-if="activeTab == 5" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Analisa Pemangku Kepentingan</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th width="5%">NO</th>
                          <th width="11%">Status</th>
                          <th width="11%">Nama</th>
                          <th width="14%">Kebutuhan/Tantangan</th>
                          <th width="11%">Dukungan</th>
                          <th width="11%">Ancaman</th>
                          <th width="11%">Strategi</th>
                          <th width="14%">Deskripsi Tindakan</th>
                          <th width="14%">Remarks</th>
                          <th width="3%" v-if="!isPreview">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in form.analisa_pemangku_jabatan"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>
                            <h6 v-if="isPreview">{{ data.status ? statusKesesuaian.find((el)=> el.value == data.status).text : '-'}}</h6>
                            <b-form-select
                            v-else
                            plain  
                            v-model="data.status"
                            :options="statusKesesuaian"
                            size="lg"
                            >
                              <template v-slot:first>
                                <b-form-select-option :value="null"
                                >Select</b-form-select-option
                                >
                              </template>
                            </b-form-select>
                          </td>
                          <td>
                            <h6 v-if="isPreview">{{data.nama ?? '-'}}</h6>
                            <b-form-input v-else v-model="data.nama" class="w-100" type="text" placeholder=""></b-form-input>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.tantangan}}
                            </template>
                            <b-form-textarea
                            v-else
                            v-model="data.tantangan"
                            style="line-height: 20px"
                            rows="4"
                            >
                          </b-form-textarea>
                        </td>
                        <td>
                            <h6 v-if="isPreview">{{ data.dukungan ? dukunganAncaman.find((el)=> el.value == data.dukungan).text : '-'}}</h6>
                            <b-form-select
                            v-else
                            plain
                            v-model="data.dukungan"
                            :options="dukunganAncaman"
                            size="lg"
                            >
                            <template v-slot:first>
                              <b-form-select-option :value="null"
                                  >Select</b-form-select-option
                                  >
                                </template>
                              </b-form-select>
                            </td>
                            <td>
                            <h6 v-if="isPreview">{{ data.ancaman ? dukunganAncaman.find((el)=> el.value == data.ancaman).text : '-'}}</h6>
                            <b-form-select
                              v-else
                              plain
                              v-model="data.ancaman"
                              :options="dukunganAncaman"
                              size="lg"
                              >
                              <template v-slot:first>
                                <b-form-select-option :value="null"
                                  >Select</b-form-select-option
                                  >
                              </template>
                            </b-form-select>
                          </td>
                          <td>
                            <h6 v-if="isPreview">{{ data.strategi ? listStrategi.find((el)=> el.value == data.strategi).text : '-'}}</h6>
                            <b-form-select
                              v-else
                              plain
                              v-model="data.strategi"
                              :options="listStrategi"
                              size="lg"
                            >
                              <template v-slot:first>
                                <b-form-select-option :value="null"
                                  >Select</b-form-select-option
                                >
                              </template>
                            </b-form-select>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.tindakan}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.tindakan"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.remarks}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.remarks"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td class="text-center" v-if="!isPreview">
                            <b-button
                              variant="danger"
                              @click="removeAnalisaPemangkuJabatan(index)"
                              ><i class="fa fa-trash"></i
                            ></b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <b-button
                      variant="warning"
                      v-if="!isPreview "
                      @click="addAnalisaPemangkuJabatan"
                      block
                      class="mt-2 mb-3"
                      ><i class="fa fa-plus"></i> Add More Data</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Analisa Pemangku Kepentingan End -->
    
            <!-- Integrasi - Sasaran Smart -->
            <b-col md="12" v-if="activeTab == 6" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Integrasi - Sasaran Smart</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th width="5%">No</th>
                          <th width="25%">Status Kesesuaian</th>
                          <th width="25%">Deskripsi</th>
                          <th width="25%">Dokumen Pendukung</th>
                          <th width="25%">Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in form.integrasi_sasaran_smart"
                          :key="index"
                        >
                          <td>{{index + 1}}</td>
                          <td>
                            <p>{{ data.kesesuaian }}</p>
                          </td>
                          <td>
                            <p>{{ data.deskripsi }}</p>
                          </td>
                          <td>
                            <div v-if="data.dokumen || isPreview" class="d-flex justify-content-between">
                              <a v-if="data.dokumen" :href="data.dokumen" class="text-primary" v-b-tooltip.hover title="Download File" download><i class="fa fa-download"></i> Download</a>
                              <h6 v-else>-</h6>
                              <a v-if="!isPreview" href="#" @click.prevent="data.dokumen = ''" class="text-danger" v-b-tooltip.hover title="Hapus" download><i class="fa fa-trash"></i></a>
                            </div>
                            <template v-else>
                              <div class="custom-file">
                                <input
                                  
                                  :id="`integrasi-sasaran-smart-file-input-${index}`"
                                  type="file"
                                  @change="
                                  onIntegrasiSasaranSmartFileChanged(
                                    index,
                                    $event
                                  )
                                "
                                  accept="image/png,image/jpg,image/jpeg,.pdf,.xls,.xlsx,.doc,.docx"
                                  class="custom-file-input"
                                />
                                <label
                                  class="custom-file-label"
                                  :for="`integrasi-sasaran-smart-file-input-${index}`"
                                >Browse file...</label
                                >
                              </div>
                              <small class="text-muted">
                                File Type * :
                                <b-badge variant="info"
                                >.jpg | .jpeg | .png | .xlx | .xlxs | .doc |
                                  .docs | .pdf</b-badge
                                ><br />
                                File Capacity * :
                                <b-badge variant="info">3 MB / File</b-badge>
                              </small>
                            </template>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.remarks}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.remarks"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Integrasi - Sasaran Smart End -->
    
            <!-- Evaluasi -->
            <b-col md="12" v-if="activeTab == 7" class="mt-3">
              <div class="px-4">
                <h5 class="text-primary mb-2"><b>Evaluasi</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th width="5%">No</th>
                          <th width="13%" class="text-truncate"  >Tahapan Kegiatan</th>
                          <th width="13%" class="text-truncate" >Sasaran Tahapan (Milestone)</th>
                          <th width="13%" class="text-truncate" >Uraian Tugas</th>
                          <th width="13%" class="text-truncate" >Indikator Keberhasilan</th>
                          <th width="12%" class="text-truncate" >Metode Evaluasi</th>
                          <th width="12%" class="text-truncate" >Frekuensi</th>
                          <th width="12%" class="text-truncate" >Remarks</th>
                          <th width="5" class="text-center" v-if="!isPreview">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(data, index) in form.evaluasi" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>
                            <template v-if="isPreview">
                              {{data.kegiatan}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.kegiatan"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.sasaran}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.sasaran"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.uraian}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.uraian"
                              style="line-height: 20px"
                              rows="4"
                            ></b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.keberhasilan}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.keberhasilan"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.evaluasi}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.evaluasi"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.frekuensi}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.frekuensi"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.remarks}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.remarks"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td v-if="!isPreview ">
                            <b-button
                              @click="removeEvaluasi(index)"
                              variant="danger"
                              ><i class="fa fa-trash"></i>
                            </b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <b-button
                      variant="warning"
                      v-if="!isPreview "
                      @click="addEvaluasi"
                      block
                      class="mt-2 mb-3"
                      ><i class="fa fa-plus"></i> Add More Data</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Evaluasi End -->
    
            <!-- Perbaikan Sinambung -->
            <b-col md="12" v-if="activeTab == 8" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Perbaikan Sinambung</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th width="5%">No</th>
                          <th width="14%" class="text-truncate">Tahapan</th>
                          <th width="14%" class="text-truncate">Sasaran Tahapan</th>
                          <th width="15%" class="text-truncate">Uraian Tugas</th>
                          <th width="14%" class="text-truncate">Indikator Keberhasilan</th>
                          <th width="14%" class="text-truncate">Hasil Evaluasi</th>
                          <th width="15%" class="text-truncate">Frekuensi</th>
                          <th width="14%" class="text-truncate">Pelaksana</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in form.perbaikan_sinambung"
                          :key="index"
                        >
                          <td>{{index + 1}}</td>
                          <td>
                            <p>{{ data.tahapan }}</p>
                          </td>
                          <td>
                            <p>{{ data.sasaran }}</p>
                          </td>
                          <td>
                            <p>{{ data.uraian }}</p>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.keberhasilan || '-'}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.keberhasilan"
                              style="line-height: 20px"
                              rows="4"
                              placeholder="Berjalannya unit manajemen resiko dengan pencapaian Terkendalinya accident/ incident setiap bulannya dengan minimum 2 major case"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.evaluasi || '-'}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.evaluasi"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.frekuensi || '-'}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.frekuensi"
                              style="line-height: 20px"
                              rows="4"
                              placeholder="Dilakukan pengawasan serta review lebih lanjut terkait hambatan-hambatan yang terjadi dalam prosesnya"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{ data.pelaksana ?? '-' }}
                            </template>
                            <b-form-input
                              v-else
                              v-model="data.pelaksana"
                              class="w-100"
                              type="text"
                              placeholder="Capt Doddy"
                            >
                            </b-form-input>
  <!--                            <b-form-select
                              plain
                              v-model="data.pelaksana"
                              :options="userLevel"
                              size="lg"
                            >
                              <template v-slot:first>
                                <b-form-select-option :value="null"
                                  >Select</b-form-select-option
                                >
                              </template>
                            </b-form-select>-->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Perbaikan Sinambung End -->
    
            <!-- Komunikasi Dan Konsultasi -->
            <b-col md="12" v-if="activeTab == 9" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Komunikasi Dan Konsultasi</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th width="4%">No</th>
                          <th width="12%">Pemangku</th>
                          <th width="12%">Konten</th>
                          <th width="12%">Tujuan</th>
                          <th width="12%">Komunikator</th>
                          <th width="12%">Waktu</th>
                          <th width="12%">Frekuensi</th>
                          <th width="12%">Media/Metode</th>
                          <th width="12%">PIC</th>
                          <th width="4%" class="text-center" v-if="!isPreview">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in form.komunikasi_konsultasi"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>
                            <template v-if="isPreview">
                              {{data.pemangku || '-'}}
                            </template>
                            <b-form-input v-else v-model="data.pemangku" class="w-100" type="text" placeholder=""></b-form-input>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.konten || '-'}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.konten"
                              style="line-height: 20px"
                              rows="4"
                              placeholder="Minimalisir risiko dan kerugian dari kejadian-kejadian yang terjadi dan melakukan evaluasi atas kendali yang sudah dan akan dilakukan kedepannya."
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.tujuan || '-'}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.tujuan"
                              style="line-height: 20px"
                              rows="4"
                              placeholder="Koordinasi dan induksi"
                            ></b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.komunikator || '-'}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.komunikator"
                              style="line-height: 20px"
                              rows="4"
                              placeholder="Superintendent, PE, PC, Radio Room, QHSE"
                            ></b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.waktu || '-'}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.waktu"
                              style="line-height: 20px"
                              rows="4"
                              placeholder="WEEKLY Meeting"
                            ></b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.frekuensi ?  frekuensi.find((el)=> el.value == data.frekuensi).text :'-' }}
                            </template>
                            <b-form-select
                              v-else
                              plain
                              v-model="data.frekuensi"
                              :options="frekuensi"
                              size="lg"
                            >
                              <template v-slot:first>
                                <b-form-select-option :value="null"
                                  >Select</b-form-select-option
                                >
                              </template>
                            </b-form-select>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.metode || '-'}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.metode"
                              style="line-height: 20px"
                              rows="4"
                              placeholder="Melalui presentasi capaian kendali saat rapat dilakukan"
                            ></b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{ data.pic ? userLevel.find((el)=> el.value == data.pic).text :'-' }}
                            </template>
                            <b-form-select
                              v-else
                              plain
                              v-model="data.pic"
                              :options="userLevel"
                              size="lg"
                            >
                              <template v-slot:first>
                                <b-form-select-option :value="null"
                                  >Select</b-form-select-option
                                >
                              </template>
                            </b-form-select>
                          </td>
                          <td class="text-center" v-if="!isPreview ">
                            <b-button
                              @click="removeKomunikasiKonsultasi(index)"
                              variant="danger"
                              ><i class="fa fa-trash"></i
                            ></b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <b-button
                      variant="warning"
                      v-if="!isPreview "
                      @click="addKomunikasiKonsultasi"
                      block
                      class="mt-2 mb-3"
                      ><i class="fa fa-plus"></i> Add More Data</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Komunikasi Dan Konsultasi End -->
    
            <!-- Raci Matrix -->
            <b-col md="12" v-if="activeTab == 10" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Raci Matrix</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <div class="overflow-auto">
                      <table class="table mb-2" v-if="raciMatrix">
                        <thead>
                          <tr>
                            <th class="text-center" rowspan="2">Details</th>
                            <th class="text-center" v-if="raciMatrix.columns" :colspan="raciMatrix.columns.length">Owner Risk</th>
                          </tr>
                          <tr v-if="raciMatrix.columns">
                            <th class="text-center text-truncate" v-for="(col, colIndex) in raciMatrix.columns" :key="colIndex">{{ col.name }}</th>
                          </tr>
                        </thead>
                        <tbody v-if="raciMatrix.rows">
                          <tr v-for="(row, rowIndex) in raciMatrix.rows" :key="rowIndex">
                            <td class="text-truncate">
                              <strong>{{ row.name }}</strong>
                            </td>
                            <template v-if="raciMatrix.columns">
                              <td class="text-center" v-for="(col, colIndex) in raciMatrix.columns" :key="colIndex">
                                <div class="d-flex" v-if="isPreview">
                                  <template v-if="raxiMatrixFormValue(row.id, col.id)?.length">
                                    <p v-for="(item, i) in raxiMatrixFormValue(row.id, col.id)" :key="i">{{ item }}{{ (i + 1) !== raxiMatrixFormValue(row.id, col.id).length ? ',':'' }}</p>
                                  </template>
                                  <template v-else>
                                    -
                                  </template>
                                </div>
                                <v-select
                                  v-else
                                  :value="raxiMatrixFormValue(row.id, col.id)"
                                  @input="onRaciMatrixChanged(row.id, col.id, $event)"
                                  multiple
                                  :options="['R', 'A', 'C', 'I']"
                                ></v-select>
    
                              </td>
                            </template>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col md="1">
                    <div class="bg-danger text-center text-white">
                      <h4 class="text-white">R</h4>
                    </div>
                  </b-col>
                  <b-col md="11">
                    <p
                      ><strong>"Responsible"</strong> adalah orang atau unit
                      yang harus melaksanakan kegiatan atau aktivitas dalam
                      mekanisme informasi dan pelaporan</p
                    >
                  </b-col>
  
                  <b-col md="1">
                    <div class="bg-warning text-center text-white">
                      <h4 class="text-white">A</h4>
                    </div>
                  </b-col>
                  <b-col md="11">
                    <p
                      ><strong>"Accountable"</strong> adalah orang atau unit
                      yang berhak membuat keputusan atas kegiatan dalam
                      mekanisme informasi dan pelaporan</p
                    >
                  </b-col>
  
                  <b-col md="1">
                    <div class="bg-success text-center text-white">
                      <h4 class="text-white">C</h4>
                    </div>
                  </b-col>
                  <b-col md="11">
                    <p
                      ><strong>"Consulted"</strong> adalah orang atau unit yang
                      harus di ajak konsultasi atau dilibatkan sebelum atau saat
                      kegiatan dalam mekanisme informasi dan pelaporan</p
                    >
                  </b-col>
  
                  <b-col md="1">
                    <div class="bg-info text-center text-white">
                      <h4 class="text-white">I</h4>
                    </div>
                  </b-col>
                  <b-col md="11">
                    <p
                      ><strong>"Informed"</strong> adalah orang atau unit yang
                      harus di beri cukup informasi mengenal kegiatan dalam
                      mekanisme informasi, berikut pelaporan hasil dan proses
                      pelaksanaan</p
                    >
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Raci Matrix End -->
    
            <!-- Kriteria Konsekuensi -->
            <b-col md="12" v-if="activeTab == 11" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Kriteria Konsekuensi</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th width="10%" class="text-truncate text-center"
                            >Skala Konsekuensi</th
                          >
                          <th width="35%" class="text-truncate"
                            >Deskripsi Skala</th
                          >
                          <th width="20%" class="text-truncate text-center"
                            >Deskripsi Kriteria</th
                          >
                          <th width="35%" class="text-truncate">Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in form.kriteria_konsekuensi"
                          :key="index"
                        >
                          <td class="text-center">
                            <p>{{ data.skala ||'-'}}</p>
                          </td>
                          <td>
                            <p>{{ data.deskripsi_skala ||'-' }}</p>
                          </td>
                          <td class="text-center">
                            <p>{{ data.deskripsi_kriteria || '-'}}</p>
                          </td>
                          <td>
                            <p>{{ data.remarks || '-' }}</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Kriteria Konsekuensi End -->
    
            <!-- Kriteria Kemungkinan -->
            <b-col md="12" v-if="activeTab == 12" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Kriteria Kemungkinan</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th width="10%" class="text-center"
                            >Skala Kemungkinan</th
                          >
                          <th width="35%" class="text-center"
                            >Deskripsi Skala</th
                          >
                          <th width="20%" class="text-center"
                            >Deskripsi Kriteria</th
                          >
                          <th width="35%" class="text-center">Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in form.kriteria_kemungkinan"
                          :key="index"
                        >
                          <td class="text-center">
                            <p>{{ data.skala }}</p>
                          </td>
                          <td>
                            <p>{{ data.deskripsi_skala }}</p>
                          </td>
                          <td class="text-center">
                            <p>{{ data.deskripsi_kriteria }}</p>
                          </td>
                          <td>
                            <p>{{ data.remarks }}</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Kriteria Kemungkinan End -->
    
            <!-- Efektifitas Kendali -->
            <b-col md="12" v-if="activeTab == 13" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Efektifitas Kendali</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th width="10%" class="text-center">Skala Efiktifitas Kendali</th>
                          <th width="35%" class="text-center">Deskripsi Skala</th>
                          <th width="20%" class="text-center">Deskripsi Kriteria</th>
                          <th width="35%" class="text-center">Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in form.efektifitas_kendali"
                          :key="index"
                        >
                          <td class="text-center">
                            <p>{{ data.skala }}</p>
                          </td>
                          <td>
                            <p>{{ data.deskripsi_skala }}</p>
                          </td>
                          <td class="text-center">
                            <p>{{ data.deskripsi_kriteria }}</p>
                          </td>
                          <td>
                            <p>{{ data.remarks }}</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Efektifitas Kendali End -->
    
            <!-- Kriteria Evaluasi -->
            <b-col md="12" v-if="activeTab == 14" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Kriteria Evaluasi</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th width="10%" class="text-center"
                            >Efiktifitas Kendali</th
                          >
                          <th width="30%" class="text-center">Selera Risiko</th>
                          <th width="30%" class="text-center"
                            >Toleransi Risiko</th
                          >
                          <th width="30%" class="text-center"
                            >Tindakan & Eskalasi</th
                          >
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in form.kriteria_evaluasi"
                          :key="index"
                        >
                          <td class="text-center">
                            <p>{{ data.skala }}</p>
                          </td>
                          <td>
                            <p>{{ data.selera }}</p>
                          </td>
                          <td>
                            <p>{{ data.toleransi }}</p>
                          </td>
                          <td>
                            <p>{{ data.tindakan }}</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Kriteria Evaluasi End -->
    
            <!-- Identifikasi Risiko -->
            <b-col md="12" v-if="activeTab == 15" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Identifikasi Risiko</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th width="5%" class="text-center">No</th>
                          <th width="25%">Sasaran</th>
                          <th width="25%">Peristiwa Risiko</th>
                          <th width="25%">Penyebab</th>
                          <th width="25%">Akibat</th>
                          <th width="25%" v-if="!isPreview">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in form.identifikasi_resiko"
                          :key="index"
                        >
                          <td>{{index + 1}}</td>
                          <td>
                            <template v-if="isPreview">
                              {{data.sasaran}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.sasaran"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.peristiwa}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.peristiwa"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.penyebab}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.penyebab"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.akibat}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.akibat"
                              style="line-height: 20px"
                              rows="4"
                            ></b-form-textarea>
                          </td>
                          <td v-if="!isPreview ">
                            <b-button
                              @click="removeIdentifikasiResiko(index)"
                              variant="danger"
                              ><i class="fa fa-trash"></i>
                            </b-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <b-button
                      variant="warning"
                      v-if="!isPreview "
                      @click="addIdentifikasiResiko"
                      block
                      class="mt-2 mb-3"
                      ><i class="fa fa-plus"></i> Add More Data</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Identifikasi Risiko End -->
    
            <!-- Analisis Dan Evaluasi Risiko -->
            <b-col md="12" v-if="activeTab == 16" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Analisis Dan Evaluasi Risiko</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th width="4%">No</th>
                          <th width="18%" class="text-truncate">Peristiwa Risiko</th>
                          <th width="8%" class="text-truncate">Efektivitas</th>
                          <th width="8%" class="text-truncate">Konsekuensi</th>
                          <th width="8%" class="text-truncate">Kemungkinan</th>
                          <th width="8%" class="text-truncate">Total Eksposur</th>
                          <th width="12%" class="text-truncate">Tingkat Risiko</th>
                          <th width="8%" class="text-truncate">Priority Risk</th>
                          <th width="18%" class="text-truncate">Evaluasi Risiko</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(data, index) in form.analisis_evaluasi_resiko"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>
                          <td>
                            <template v-if="isPreview">
                              {{data.peristiwa}}
                            </template>
                            <b-form-textarea
                              v-else
                              v-model="data.peristiwa"
                              style="line-height: 20px"
                              rows="4"
                            >
                            </b-form-textarea>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.efektifitas}}
                            </template>
                            <b-form-select
                              
                              v-else
                              plain
                              v-model="data.efektifitas"
                              :options="number"
                              size="lg"
                            >
                              <template v-slot:first>
                                <b-form-select-option :value="''"
                                >Select</b-form-select-option
                                >
                              </template>
                            </b-form-select>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.konsekuensi}}
                            </template>
                            <b-form-select
                              
                              v-else
                              plain
                              v-model="data.konsekuensi"
                              :options="number"
                              size="lg"
                            >
                              <template v-slot:first>
                                <b-form-select-option :value="''"
                                >Select</b-form-select-option
                                >
                              </template>
                            </b-form-select>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.kemungkinan}}
                            </template>
                            <b-form-select
                            
                              v-else
                              plain
                              v-model="data.kemungkinan"
                              :options="number"
                              size="lg"
                            >
                              <template v-slot:first>
                                <b-form-select-option :value="''"
                                >Select</b-form-select-option
                                >
                              </template>
                            </b-form-select>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.eksposur}}
                            </template>
                            <p v-else>
                              {{data.eksposur = Number(data.konsekuensi) * Number(data.kemungkinan)}}
                            </p>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.tingkat_risiko}}
                            </template>
                            <b-form-select
                              v-else
                              plain
                              v-model="data.tingkat_risiko"
                              size="lg"
                            >
                              <template v-slot:first>
                                <b-form-select-option value="Rendah"
                                  >Rendah</b-form-select-option
                                >
                                <b-form-select-option value="Sedang"
                                  >Sedang</b-form-select-option
                                >
                                <b-form-select-option value="Tinggi"
                                  >Tinggi</b-form-select-option
                                >
                              </template>
                            </b-form-select>
                          </td>
                          <td class="text-center">
                            <template v-if="isPreview" >
                              {{ data.prioritas }}
                            </template>
                            <b-form-select
                              v-else
                              plain
                              v-model="data.prioritas"
                              size="lg"
                            >
                              <template v-slot:first>
                                <b-form-select-option :value="null"
                                  >Select</b-form-select-option
                                >
                              </template>
                              <b-form-select-option v-for="(n, i) in 10" :value="n" :key="i"
                              >{{ n }}</b-form-select-option
                              >
                            </b-form-select>
                          </td>
                          <td>
                            <template v-if="isPreview">
                              {{data.evaluasi}}
                            </template>
                            <b-form-select
                            
                              v-else
                              plain
                              v-model="data.evaluasi"
                              size="lg"
                            >
                              <template v-slot:first>
                                <b-form-select-option value="Tolak"
                                >Tolak</b-form-select-option
                                >
                                <b-form-select-option value="Turunkan"
                                >Turunkan</b-form-select-option
                                >
                                <b-form-select-option value="Berbagi"
                                >Berbagi</b-form-select-option
                                >
                                <b-form-select-option value="Terima"
                                >Terima</b-form-select-option
                                >
                              </template>
                            </b-form-select>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Analisis Dan Evaluasi Risiko End -->
    
            <!-- Peta Risiko - Before -->
            <b-col md="12" v-if="activeTab == 17" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Peta Risiko - Before</b></h5> 
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                        <tr>
                          <th rowspan="2" class="text-center">Likelihood/Kemungkinan/</th>
                          <th colspan="5" class="text-center">Impact/Konsekuensi</th>
                        </tr>
                        <tr>
                          <th class="text-center" v-for="col in 5" :key="col">{{ col }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="row in 5" :key="row">
                          <td class="text-center">
                            <p>{{row}}</p>
                          </td>
                          <td class="text-center" v-for="col in 5" :key="col" :class="{'bg-danger text-white' : petaRisikoBefore(row, col).length > 0}">
                            {{ petaRisikoBefore(row, col).map((r, ir) => ir+1).join(',')}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Peta Risiko - Before End -->
    
            <!-- Perlakuan Risiko -->
            <b-col md="12" v-if="activeTab == 18" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Perlakuan Risiko</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <div class="overflow-auto">
                      <table class="table mb-2">
                        <thead>
                          <tr>
                            <th  class="text-truncate">Peristiwa Risiko</th>
                            <th  class="text-truncate">Total Eksposur</th>
                            <th  class="text-truncate">Evaluasi Risiko</th>
                            <th  class="text-truncate">Tindakan/Kendali</th>
                            <th  class="text-truncate">Frekuensi Pemantauan</th>
                            <th  class="text-truncate">Frekuensi Pelaporan</th>
                            <th  class="text-truncate">Konsekuensi Residual</th>
                            <th  class="text-truncate">Kemungkinan Residual</th>
                            <th  class="text-truncate">Total Eksposur Residual</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(data, index) in form.perlakuan_resiko" :key="index">
                            <td>{{ data.peristiwa }}</td>
                            <td class="text-center">{{ data.total_eksposur }}</td>
                            <td class="text-center">{{ data.evaluasi_resiko }}</td>
                            <td>
                              {{ data.tindakan }}
                            </td>
                            <td class="text-center">
                              <b-form-select
                              
                                plain
                                v-model="data.frekuensi_pemantauan"
                                :options="frekuensi"
                                size="lg"
                              >
                                <template v-slot:first>
                                  <b-form-select-option :value="null"
                                    >Select</b-form-select-option
                                  >
                                </template>
                              </b-form-select>
                            </td>
                            <td class="text-center">
                              <b-form-select
                              
                                plain
                                v-model="data.frekuensi_pelaporan"
                                :options="frekuensi"
                                size="lg"
                              >
                                <template v-slot:first>
                                  <b-form-select-option :value="null"
                                    >Select</b-form-select-option
                                  >
                                </template>
                              </b-form-select>
                            </td>
                            <td class="text-center">
                              <b-form-select
                              
                                plain
                                v-model="data.konsekuensi_residual"
                                :options="number"
                                size="lg"
                              >
                                <template v-slot:first>
                                  <b-form-select-option :value="null"
                                    >Select</b-form-select-option
                                  >
                                </template>
                              </b-form-select>
                            </td>
                            <td class="text-center">
                              <b-form-select
                              
                                plain
                                v-model="data.kemungkinan_residual"
                                :options="number"
                                size="lg"
                              >
                                <template v-slot:first>
                                  <b-form-select-option :value="null"
                                    >Select</b-form-select-option
                                  >
                                </template>
                              </b-form-select>
                            </td>
                            <td class="text-center">
                              {{data.total_eksposur_residual = Number(data.konsekuensi_residual) * Number(data.kemungkinan_residual)}}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Perlakuan Risiko End -->
    
            <!-- Peta Risiko - After -->
            <b-col md="12" v-if="activeTab == 19" class="mt-3">
              <div class="px-4">
                <h5 class="card-title text-primary"><b>Peta Risiko - After</b></h5>
                <b-row>
                  <b-col md="12" class="mt-2 m-auto">
                    <table class="table mb-2">
                      <thead>
                      <tr>
                        <th rowspan="2" class="text-center">Likelihood/Kemungkinan/</th>
                        <th colspan="5" class="text-center">Impact/Konsekuensi</th>
                      </tr>
                      <tr>
                        <th class="text-center" v-for="col in 5" :key="col">{{ col }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="row in 5" :key="row">
                        <td class="text-center">
                          <p>{{row}}</p>
                        </td>
                        <td class="text-center" v-for="col in 5" :key="col" :class="{'bg-success text-white' : petaRisikoAfter(row, col).length > 0}">
                          {{ petaRisikoAfter(row, col).map((r, ir) => ir+1).join(',')}}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <!-- Peta Risiko - After End -->

            <b-col md="12" class="text-right mb-4">
              <!-- <a v-if="isPreview" class="btn btn-primary" :href="`/mi/enterprise-risk-management?formId=${detailMi.id}`"
              >Edit</a> -->
              <b-button v-if="!isPreview" type="submit" class="mr-3" :disabled="form._saving" variant="primary">Simpan Data</b-button>
            </b-col>
          </b-row>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { companiesActions, filesActions, fleetsActions, miActions } from '@src/Utils/helper'
import moment from 'moment'
import StepNavigation from '@src/views/MI/component/StepNavigation'
import StepWizard from '@src/views/MI/component/StepWizard'
import { xray } from '@/src/config/pluginInit';
import TabPaneVertical from '../component/TabPaneVertical.vue';

export default {
  name: 'EnterpriseRiskManagement',
  components: { StepNavigation, StepWizard, TabPaneVertical },
  async mounted () {
    xray.index()
    if (this.$route.query.formId) {
      await this.fetchCompanies()
      await this.fetchDepartments()
      await this.fetchMasterErm()
      await this.fetchRaciMatrix()
      if (this.detailMi) {
        await this.fetchMi()
      }
    }

    if (this.$route.query.preview === 'true' || this.$route.query.preview === true) {
      this.isPreview = true
    }
  },
  props:{
    detailMi:null
  },
  data () {
    return {
      permission_user:JSON.parse(localStorage.getItem('profile')).role.roles,
      isPreview: true,
      // detailMi: null,
      raciMatrix: null,
      form: {
        _saving: false,
        status: false,
        date_range: [],
        assessor_fullname: '',
        assessor_company_id: '',
        assessor_erm_credential: '',
        assessor_department_id: '',
        target_department_id: [],
        target_location: '',
        target_pic: '',
        target_from: '',
        target_to: '',
        sasaran_smart: [],
        penamaan_resiko: [],
        prinsip_manajemen_resiko: [],
        kepemimpinan_komitmen: [],
        analisa_pemangku_jabatan: [],
        integrasi_sasaran_smart: [],
        evaluasi: [],
        perbaikan_sinambung: [],
        komunikasi_konsultasi: [],
        identifikasi_resiko: [],
        analisis_evaluasi_resiko: [],
        kriteria_konsekuensi: [],
        kriteria_kemungkinan: [],
        kriteria_evaluasi: [],
        efektifitas_kendali: [],
        perlakuan_resiko: [],
        raci_matrix: []
      },
      listRisk: [
        { value: 'FINANCIAL', text: 'Financial Risk' },
        { value: 'NONFINANCIAL', text: 'Non Financial Risk' }
      ],
      catRisk: [
        { value: 'TECHNICAL', text: 'Technical Risk' },
        { value: 'OPERATIONAL', text: 'Operational Risk' }
      ],
      statusImplementasi: [
        { value: 'BERJALAN', text: 'Berjalan' },
        { value: 'TIDAKBERJALAN', text: 'Tidak Berjalan' },
        { value: 'SEBAGIAN', text: 'Sebagian' }
      ],
      userLevel: [
        { value: 'SITE MANAGER', text: 'Site Manager' },
        { value: 'SUPERINTENDENT', text: 'Superintendent' },
        { value: 'PE', text: 'Port Engineer' },
        { value: 'PC', text: 'Port Captain' },
        { value: 'ETC', text: 'etc..' }
      ],
      statusKesesuaian: [
        { value: 'INTERNAL', text: 'Internal' },
        { value: 'EXTERNAL', text: 'External' },
        { value: 'NA', text: 'N/A' },
        { value: 'TBA', text: 'TBA' }
      ],
      dukunganAncaman: [
        { value: 'TINGGI', text: 'Tinggi' },
        { value: 'RENDAH', text: 'Rendah' }
      ],
      listStrategi: [
        { value: 'KEEP INFORMED', text: 'Keep Informed' },
        { value: 'KEEP SATIFIED', text: 'Keep Statisfied' }
      ],
      frekuensi: [
        { value: 'HARIAN', text: 'Harian' },
        { value: 'MINGGUAN', text: 'Mingguan' },
        { value: 'BULANAN', text: 'Bulanan' },
        { value: '3BULANAN', text: '3 Bulanan' },
        { value: '6BULANAN', text: '6 Bulanan' },
        { value: 'TAHUNAN', text: 'Tahunan' }
      ],
      number: [
        { value: '1', text: '1' },
        { value: '2', text: '2' },
        { value: '3', text: '3' },
        { value: '4', text: '4' },
        { value: '5', text: '5' }
      ],
      evaluasiResiko: [
        { value: '1', text: 'Tolak' },
        { value: '2', text: 'Turunkan' },
        { value: '3', text: 'Berbagi' },
        { value: '4', text: 'Terima' }
      ],
      statusYesNo: [
        { value: '1', text: 'Yes' },
        { value: '2', text: 'No' }
      ],

      companies: [],
      departments: [],
      activeTab:1
    }
  },
  watch: {
    isPreview (value) {
      const inputs = document.getElementById('erm-form').querySelectorAll('input,select')
      if (inputs) {
        for (const input of inputs) {
          input.classList.remove('transparent-disabled')
          input.removeAttribute('disabled')
        }

        if (typeof value === 'boolean') {
          if (value) {
            for (const input of inputs) {
              input.classList.add('transparent-disabled')
              input.setAttribute('disabled', 'disabled')
            }
          }
        }
      }
    }
  },
  computed:{
    userPermission(){
      if(['SUPER ADMIN', 'MARINE INSURANCE', 'MARINE INSURANCE ADMIN', 'MARINE INSURANCE MANAGER'].includes(this.permission_user)){
        return true
      } else{
        return false
      } 
    }
  },
  methods: {
    ...fleetsActions,
    ...companiesActions,
    ...miActions,
    ...filesActions,

    async fetchMi () {
      // const { data, status } = await this.fetchDetailMi({
      //   id: this.$route.query.formId,
      //   with: 'vehicle,type_coverage,type_loss,company,documents,company_claimant,status,creator,histories,evaluations,erm'
      // })

      // if ([500, 404, 403].includes(status)) {
      //   this.$swal(`Oops!`, 'Ada Yang Salah', 'error')
      //   this.form._saving = false
      //   return
      // }

      // this.detailMi = data

      if (this.detailMi.evaluations) {
        this.detailMi.evaluations.forEach(evaluation => {
          this.form.evaluasi.push({
            kegiatan: evaluation.activity_stage,
            sasaran: evaluation.milestone,
            uraian: evaluation.job_description,
            keberhasilan: evaluation.success_indicator,
            evaluasi: evaluation.evaluation_result,
            frekuensi: evaluation.frequency,
            remarks: ''
          })
        })
      }

      if (this.detailMi.erm) {
        const erm = this.detailMi.erm
        this.form.assessor_fullname = erm.assessor_fullname
        this.form.assessor_company_id = erm.assessor_company_id
        this.form.assessor_erm_credential = erm.assessor_erm_credential
        this.form.assessor_department_id = erm.assessor_department_id
        this.form.target_pic = erm.target_pic
        this.form.target_department_id = erm.target_department_id
        this.form.target_location = erm.target_location
        this.form.target_from = erm.target_from
        this.form.target_to = erm.target_to
        if (erm.target_from && erm.target_to) {
          this.form.date_range = [moment(erm.target_from).format('YYYY-MM-DD'), moment(erm.target_to).format('YYYY-MM-DD')]
        }
        this.form.sasaran_smart = erm.sasaran_smart.map(array => {
          if (array.timebound) {
            array.timebound = moment(array.timebound).format('YYYY-MM-DD')
          }
          return { ...array }
        })
        this.form.penamaan_resiko = erm.penamaan_resiko.map(array => {
          return { ...array }
        })
        this.form.prinsip_manajemen_resiko = erm.prinsip_manajemen_resiko.map(array => {
          return { ...array }
        })
        this.form.kepemimpinan_komitmen = erm.kepemimpinan_komitmen.map(array => {
          return { ...array }
        })
        this.form.analisa_pemangku_jabatan = erm.analisa_pemangku_jabatan.map(array => {
          return { ...array }
        })
        this.form.integrasi_sasaran_smart = erm.integrasi_sasaran_smart.map(array => {
          return { ...array }
        })
        this.form.evaluasi = erm.evaluasi.map(array => {
          return { ...array }
        })
        this.form.perbaikan_sinambung = erm.perbaikan_sinambung.map(array => {
          return { ...array }
        })
        this.form.komunikasi_konsultasi = erm.komunikasi_konsultasi.map(array => {
          return { ...array }
        })
        this.form.identifikasi_resiko = erm.identifikasi_resiko.map(array => {
          return { ...array }
        })
        this.form.analisis_evaluasi_resiko = erm.analisis_evaluasi_resiko.map(array => {
          return { ...array }
        })
        this.form.perlakuan_resiko = erm.perlakuan_resiko.map(array => {
          return { ...array }
        })
        this.form.raci_matrix = erm.raci_matrix.map(array => {
          return { ...array }
        })

        if (this.form.raci_matrix.length === 0) {
          await this.fetchRaciMatrix()
        }
      }
    },
    async fetchCompanies () {
      let res = await this.getCompanies()
      this.companies = res.data
    },
    async fetchDepartments () {
      this.departments = []
      let res = await this.getDepartments({})

      if (res.status) {
        if (res.data && res.data.length > 0) {
          res.data.forEach((el) => {
            this.departments.push({
              name: el.name,
              code: el.id
            })
          })
        }
      }
    },
    async fetchMasterErm () {
      let self = this
      let res = await this.getMasterAllErm({})

      if (res.status) {
        if (res.data) {
          if (res.data.prinsip_manajemen_resiko) {
            self.form.prinsip_manajemen_resiko = []
            res.data.prinsip_manajemen_resiko.map((result) => {
              self.form.prinsip_manajemen_resiko.push({
                prinsip: result.risiko,
                definisi: result.definisi,
                implementasi: '',
                status: '' // SEBAGIAN|TIDAK BERJALAN
              })
            })
          }
          if (res.data.perbaikan_sinambung) {
            self.form.perbaikan_sinambung = []
            res.data.perbaikan_sinambung.map((result) => {
              self.form.perbaikan_sinambung.push({
                tahapan: result.tahapan,
                sasaran: result.sasaran,
                uraian: result.uraian,
                keberhasilan: '',
                evaluasi: '',
                frekuensi: '',
                pelaksana: '' // SITE MANAGER|SUPERINTENDENT|PE|PC|ETC
              })
            })
          }
          if (res.data.kriteria_konsekuensi) {
            self.form.kriteria_konsekuensi = []
            res.data.kriteria_konsekuensi.map((result) => {
              self.form.kriteria_konsekuensi.push(result)
            })
          }
          if (res.data.kriteria_kemungkinan) {
            self.form.kriteria_kemungkinan = []
            res.data.kriteria_kemungkinan.map((result) => {
              self.form.kriteria_kemungkinan.push(result)
            })
          }
          if (res.data.kriteria_evaluasi) {
            self.form.kriteria_evaluasi = []
            res.data.kriteria_evaluasi.map((result) => {
              self.form.kriteria_evaluasi.push(result)
            })
          }
          if (res.data.efektifitas_kendali) {
            self.form.efektifitas_kendali = []
            res.data.efektifitas_kendali.map((result) => {
              self.form.efektifitas_kendali.push(result)
            })
          }
        }
      }
    },
    async fetchRaciMatrix () {
      let { data, status } = await this.getRaciMatrix()

      if (status === 'success') {
        if (data) {
          this.raciMatrix = data
          this.form.raci_matrix = []
          if (data.rows && data.columns) {
            data.rows.forEach(row => {
              data.columns.forEach(column => {
                this.form.raci_matrix.push({
                  raci_matrix_id: row.id,
                  department_id: column.id,
                  value: []
                })
              })
            })
          }
        }
      }
    },
    async onSave () {
      let payload = this.form
      payload.assessor_company_id = parseInt(payload.assessor_company_id)
      payload.assessor_department_id = parseInt(payload.assessor_department_id)
      payload.target_department_id = [parseInt(payload.target_department_id)]
      this.form._saving = true

      const { status } = await this.saveERM({
        form_id: this.$route.query.formId,
        data: payload
      })

      if (status === 422) {
        this.$swal(`Oops!`, 'Semua Field Wajib Diisi', 'error')
        this.form._saving = false
        return
      }

      if ([500, 404, 403].includes(status)) {
        this.$swal(`Oops!`, 'Ada Yang Salah', 'error')
        this.form._saving = false
        return
      }

      this.$swal(`Tersimpan`, 'Data Tersimpan', 'success')

      setTimeout(() => {
        this.$router.push('/mi/list-initial')
      }, 1500)

      this.form._saving = false
    },
    async handleFileRemoteUpload (event) {
      const files = [...event.target.files]
      let file = files[0]

      let formData = new FormData()
      formData.append('file', file)

      const { data, status } = await this.upload(formData)

      if (status === 'error') {
        return {
          status
        }
      }

      return {
        data, status
      }
    },
    onChangeDate () {
      this.form.target_from = this.form.date_range
        ? moment(this.form.date_range[0]).format('YYYY-MM-DD')
        : ''
      this.form.target_to = this.form.date_range
        ? moment(this.form.date_range[1]).format('YYYY-MM-DD')
        : ''
    },
    addSasaranSmart () {
      this.form.sasaran_smart.push({
        sasaran: '',
        spesific: '',
        measurable: '',
        achievable: '',
        relevant: '',
        timebound: ''
      })

      this.addIntegrasiSasaranSmart()
      this.addPenamaanResiko()
      this.addIdentifikasiResiko()
      this.addAnalisaEvaluasiResiko()
      this.addPerlakuanResiko()
    },
    removeSasaranSmart (index) {
      this.form.sasaran_smart.splice(index, 1)
      this.removeIntegrasiSasaranSmart(index)
    },
    onSasaranSmartChanged (index) {
      this.form.integrasi_sasaran_smart[index].kesesuaian = this.form.sasaran_smart[index].sasaran
      this.form.integrasi_sasaran_smart[index].deskripsi = this.form.sasaran_smart[index].spesific

      this.form.penamaan_resiko[index].sasaran = this.form.sasaran_smart[index].sasaran

      this.form.identifikasi_resiko[index].sasaran = this.form.sasaran_smart[index].sasaran

      this.form.analisis_evaluasi_resiko[index].peristiwa = this.form.sasaran_smart[index].sasaran

      this.form.perlakuan_resiko[index].peristiwa = this.form.sasaran_smart[index].sasaran
    },
    addPenamaanResiko () {
      this.form.penamaan_resiko.push({
        sasaran: '',
        risiko: '', // FINANCIAL RISK|NON FINANCIAL RISK
        peristiwa: '',
        sebab: '',
        konsekuensi: '',
        kategori_risiko: '', // TECHNICAL RISK|OPERATIONAL RISK
        tindakan: ''
      })
    },
    onPenamaanResikoChanged (index) {
      this.form.identifikasi_resiko[index].peristiwa = this.form.penamaan_resiko[index].peristiwa
      this.form.identifikasi_resiko[index].penyebab = this.form.penamaan_resiko[index].sebab
      this.form.identifikasi_resiko[index].akibat = this.form.penamaan_resiko[index].konsekuensi

      this.form.perlakuan_resiko[index].tindakan = this.form.penamaan_resiko[index].tindakan
    },
    removePenamaanResiko (index) {
      this.form.penamaan_resiko.splice(index, 1)
    },
    addKepemimpinanKomitment () {
      this.form.kepemimpinan_komitmen.push({
        pimpinan: '', // SITE MANAGER|SUPERINTENDENT|PE|PC|ETC
        tugas: '',
        dokumen: '', // base64 arrays
        remarks: ''
      })
    },
    removeKepemimpinanKomitment (index) {
      this.form.kepemimpinan_komitmen.splice(index, 1)
    },
    async onKepemimpinanKomitmentFileChanged (index, event) {
      const { data, status } = await this.handleFileRemoteUpload(event)

      if (status === 'success') {
        this.form.kepemimpinan_komitmen[index].dokumen = data.fileName

        return true
      }

      const reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = () => {
        this.form.kepemimpinan_komitmen[index].dokumen = reader.result
      }
    },
    addAnalisaPemangkuJabatan () {
      this.form.analisa_pemangku_jabatan.push({
        status: '',
        nama: '', // SITE MANAGER|SUPERINTENDENT|PE|PC|ETC
        tantangan: '', // TINGGI|RENDAH
        dukungan: '', // TINGGI|RENDAH
        ancaman: '', // TINGGI/RENDAH
        strategi: '', // KEEP INFORMED|KEEP SATIFIED
        tindakan: '',
        remarks: ''
      })
    },
    removeAnalisaPemangkuJabatan (index) {
      this.form.analisa_pemangku_jabatan.splice(index, 1)
    },
    addKomunikasiKonsultasi () {
      this.form.komunikasi_konsultasi.push({
        pemangku: '', // SITE MANAGER|SUPERINTENDENT|PE|PC|ETC
        konten: '',
        tujuan: '',
        komunikator: '',
        waktu: '',
        frekuensi: '', // HARIAN|MINGGUAN|BULANAN|3 BULANAN|6 BULANAN|TAHUNAN
        metode: '',
        pic: '' // SITE MANAGER|SUPERINTENDENT|PE|PC|ETC
      })
    },
    removeKomunikasiKonsultasi (index) {
      this.form.komunikasi_konsultasi.splice(index, 1)
    },
    addIntegrasiSasaranSmart () {
      this.form.integrasi_sasaran_smart.push({
        kesesuaian: '',
        deskripsi: '',
        dokumen: '',
        remarks: ''
      })
    },
    removeIntegrasiSasaranSmart (index) {
      this.form.integrasi_sasaran_smart.splice(index, 1)
    },
    async onIntegrasiSasaranSmartFileChanged (index, event) {
      const { data, status } = await this.handleFileRemoteUpload(event)

      if (status === 'success') {
        this.form.integrasi_sasaran_smart[index].dokumen = data.fileName

        return true
      }

      const reader = new FileReader()
      reader.readAsDataURL(event.target.files[0])
      reader.onload = () => {
        this.form.integrasi_sasaran_smart[index].dokumen = reader.result
      }
    },
    addEvaluasi () {
      this.form.evaluasi.push({
        kegiatan: '',
        sasaran: '',
        uraian: '',
        keberhasilan: '',
        evaluasi: '',
        frekuensi: '',
        remarks: ''
      })
    },
    removeEvaluasi (index) {
      this.form.evaluasi.splice(index, 1)
    },
    addIdentifikasiResiko () {
      this.form.identifikasi_resiko.push({
        sasaran: '',
        peristiwa: '',
        penyebab: '',
        akibat: ''
      })
    },
    removeIdentifikasiResiko (index) {
      this.form.identifikasi_resiko.splice(index, 1)
    },
    addAnalisaEvaluasiResiko () {
      this.form.analisis_evaluasi_resiko.push({
        peristiwa: '',
        efektifitas: '',
        konsekuensi: '',
        kemungkinan: '',
        eksposur: '',
        tingkat_risiko: '',
        prioritas: '',
        evaluasi: ''
      })
    },
    onAnalisaEvaluasiResikoChanged (index) {
      this.form.perlakuan_resiko[index].total_eksposur = this.form.analisis_evaluasi_resiko[index].eksposur
      this.form.perlakuan_resiko[index].evaluasi_resiko = this.form.analisis_evaluasi_resiko[index].evaluasi
    },
    removeAnalisaEvaluasiResiko (index) {
      this.form.analisis_evaluasi_resiko.splice(index, 1)
    },
    addPerlakuanResiko () {
      this.form.perlakuan_resiko.push({
        peristiwa: '',
        total_eksposur: '',
        evaluasi_resiko: '',
        tindakan: '',
        frekuensi_pemantauan: 'HARIAN',
        frekuensi_pelaporan: 'HARIAN',
        konsekuensi_residual: '',
        kemungkinan_residual: '',
        total_eksposur_residual: ''
      })
    },
    removePerlakuanResiko (index) {
      this.form.perlakuan_resiko.splice(index, 1)
    },
    onRaciMatrixChanged (matrixId, departmentId, value) {
      const form = this.form.raci_matrix.find(matrix => matrix.raci_matrix_id === matrixId && matrix.department_id === departmentId)
      if (form) {
        form.value = value
        return form
      }

      return null
    },
    raxiMatrixFormValue (matrixId, departmentId) {
      const form = this.form.raci_matrix.find(matrix => matrix.raci_matrix_id === matrixId && matrix.department_id === departmentId)
      if (form) {
        return form.value
      }

      return null
    },
    petaRisikoBefore (likelihoodNumber, impactNumber) {
      return this.form.analisis_evaluasi_resiko.filter(row => Number(row.kemungkinan) === Number(likelihoodNumber) && Number(row.konsekuensi) === Number(impactNumber))
    },
    petaRisikoAfter (likelihoodNumber, impactNumber) {
      return this.form.perlakuan_resiko.filter(row => Number(row.kemungkinan_residual) === Number(likelihoodNumber) && Number(row.konsekuensi_residual) === Number(impactNumber))
    }
  }
}
</script>
